var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      attrs: {
        title: "Vote",
        visible: _vm.isOpen,
        width: "7.2rem",
        "append-to-body": "",
        "close-on-click-modal": false,
        "destroy-on-close": "",
      },
      on: {
        "update:visible": function ($event) {
          _vm.isOpen = $event
        },
      },
    },
    [
      _c("div", { staticClass: "detail-item spaceLeft" }, [
        _c("span", { staticClass: "detail-item-label" }, [
          _vm._v("Proposal No :"),
        ]),
        _vm._v(" "),
        _c("span", [_vm._v(_vm._s(_vm.rowData.id))]),
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "detail-item" },
        [
          _c("voteProgress", {
            attrs: {
              cumulative: _vm.rowData.totalWeight,
              threshold: _vm.rowData.threshold,
            },
            on: {
              "update:cumulative": function ($event) {
                return _vm.$set(_vm.rowData, "totalWeight", $event)
              },
              "update:threshold": function ($event) {
                return _vm.$set(_vm.rowData, "threshold", $event)
              },
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c("div", { staticClass: "detail-item spaceLeft" }, [
        _c("span", { staticClass: "detail-item-label" }, [_vm._v("Vote :")]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "balance-box" },
          [
            _c(
              "el-input",
              {
                attrs: { type: "number" },
                on: { change: _vm.checkVal },
                model: {
                  value: _vm.inputVal,
                  callback: function ($$v) {
                    _vm.inputVal = $$v
                  },
                  expression: "inputVal",
                },
              },
              [
                _c("template", { slot: "append" }, [
                  _c(
                    "span",
                    { staticClass: "unit" },
                    [
                      _vm._v("Balance : "),
                      _c("big-number", { attrs: { number: _vm.balance } }),
                    ],
                    1
                  ),
                ]),
              ],
              2
            ),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _c(
        "span",
        {
          staticClass: "dialog-footer",
          attrs: { slot: "footer" },
          slot: "footer",
        },
        [
          _c("el-button", { on: { click: _vm.close } }, [_vm._v("Cancel")]),
          _vm._v(" "),
          _c("loading-btn", {
            staticClass: "common-btn-blue-sm",
            attrs: { label: "Submit" },
            on: { clickHandle: _vm.save },
          }),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }